export default function LayoutPage({ children }) {
  return <div>{children}</div>;
}
